import React from "react";
var __jsx = React.createElement;
import TitleSection from "@/pages/checkout/finance-checkout/FreeFinanceComponents/TitleSection";
import { useTranslation } from "@i18n";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import { CDN_LINK } from "@globalConfig";
var MobileHeader = function MobileHeader(_ref) {
  var isOtpStep = _ref.isOtpStep,
    financestep = _ref.financestep,
    loader = _ref.loader,
    updateShowPopUp = _ref.updateShowPopUp,
    _ref$hideTitleSection = _ref.hideTitleSection,
    hideTitleSection = _ref$hideTitleSection === void 0 ? false : _ref$hideTitleSection;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var _useAribFinance$actio = useAribFinance().actions,
    action__getCurrentTitle = _useAribFinance$actio.action__getCurrentTitle,
    action__backButtonClick = _useAribFinance$actio.action__backButtonClick;
  var hiddenSteps = [3, 4, 6, 7, 8, 9];
  if (hiddenSteps.includes(financestep)) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-white pt-[10px] pb-[5px] px-[5%]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-between border-b border-[#EBF0F7] pb-4 mb-[10px] border-solid"
  }, /*#__PURE__*/React.createElement("span", null, !isOtpStep && /*#__PURE__*/React.createElement("span", {
    onClick: action__backButtonClick
  }, /*#__PURE__*/React.createElement("img", {
    className: "en:transform en:[transform:rotateY(180deg)]",
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/mobileBackBlueArr.svg"
  }))), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-base font-bold leading-6"
  }, !isOtpStep && action__getCurrentTitle()), /*#__PURE__*/React.createElement("span", null, financestep !== 3 && financestep !== 4 && financestep !== 5 && /*#__PURE__*/React.createElement("button", {
    className: "text-[#3C56D4] text-xs font-bold leading-4 underline border-none bg-transparent",
    onClick: function onClick() {
      return updateShowPopUp(true);
    }
  }, t("cancel", {
    ns: "web_checkout_finance"
  })))), /*#__PURE__*/React.createElement("div", null, !isOtpStep || hideTitleSection && /*#__PURE__*/React.createElement(TitleSection, {
    step: +financestep
  }))));
};
export default MobileHeader;